
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { BagInfo } from "./bag/BagInfo";

export interface BagInfo {
  id: string;
  styleNumber: string;
  name: string;
  description: string;
  measurements: {
    height: string;
    width: string;
    depth: string;
    strap?: string;
    alternate?: string;
  };
  years: string;
  alternativeName?: string;
  colors?: string;
  mainImage?: string;
  alternateStyleNumber?: string;
  catalogPages?: { id: string; previewUrl: string }[];
}

interface BagDetailsProps {
  bag: BagInfo | null;
  isLoading?: boolean;
}

export const BagDetails = ({ bag, isLoading }: BagDetailsProps) => {
  console.log('BagDetails received:', { bag, isLoading });

  if (isLoading) {
    return <LoadingSkeleton />;
  }

  if (!bag) {
    return null;
  }

  return <BagInfo bag={bag} />;
};

const LoadingSkeleton = () => (
  <Card className="overflow-hidden bg-white/80 backdrop-blur-sm border-2 border-gold/20">
    <div className="p-6 space-y-6 text-left">
      <div className="space-y-2">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-8 w-64" />
      </div>
      <Skeleton className="h-20 w-full" />
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <div key={i}>
            <Skeleton className="h-4 w-16 mb-1" />
            <Skeleton className="h-6 w-20" />
          </div>
        ))}
      </div>
      <div>
        <Skeleton className="h-4 w-32 mb-1" />
        <Skeleton className="h-6 w-24" />
      </div>
    </div>
  </Card>
);
